<div class="release-grid">
  @for (i of albums(); track i.id) {
  <div>
    <mat-card class="new-release-card">
      <mat-card-header>
        <mat-card-title class="album-title">{{i?.name}}</mat-card-title>
        <mat-card-subtitle>{{subtitle()}}</mat-card-subtitle>
        <div class="card-actions">
        <app-deezer-link kind="album" [id]="i.id" [name]="i.name" />
        @if (favouriteIds(); as ids) {
        <button type="button" class="heart" [class.saved]="ids.has(i.id)" (click)="favouriteToggle.emit(i)"
          [attr.aria-pressed]="ids.has(i.id)"
          [attr.aria-label]="(ids.has(i.id) ? 'Remove from' : 'Add to') + ' Favourite Albums: ' + i.name"
          [title]="ids.has(i.id) ? 'Remove from Favourite Albums' : 'Add to Favourite Albums'">
          <mat-icon>{{ids.has(i.id) ? 'favorite' : 'favorite_border'}}</mat-icon>
        </button>
        }
        </div>
      </mat-card-header>

      <div class="img-container">
        <img [routerLink]="['/album', i.id]" [src]="i.images[0]?.url" class="album-cover"
          alt="{{i?.name}} album cover" />
      </div>

      <mat-card-content>
        <div style="margin-top: 10px;">
          <p><strong>Release Date: </strong> {{i.release_date}}</p>
          <p><strong>Tracks: </strong> {{i.total_tracks || '—'}}</p>
        </div>

        <div class="artist-chips">
          @for (a of i.artists; track a.id) {
          <mat-chip [routerLink]="['/artist', a.id]" style="cursor: pointer;">{{a.name}}</mat-chip>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
</div>
